import { find } from 'lodash'

const module = 'DATE_RANGE_'

export const INIT_DATE_RANGE = module + 'initDateRange'
export const UPDATE_START_DATE = module + 'updateStartDate'
export const UPDATE_END_DATE = module + 'updateEndDate'

import {
  SET_AVAILABLE_DATES,
  SET_START_DATE,
  SET_END_DATE
} from './mutations'

export default {
  [INIT_DATE_RANGE] ({ commit, state }, dateRange, startDate) {
    commit(SET_AVAILABLE_DATES, dateRange)
    commit(SET_START_DATE, startDate)
    commit(SET_END_DATE, dateRange[dateRange.length - 1])
  },
  [UPDATE_START_DATE] ({ dispatch, commit, state }, startDateFrom) {
    const newStartDate = find(state.availableDates, date => date.from === startDateFrom)
    commit(SET_START_DATE, newStartDate)
  },
  [UPDATE_END_DATE] ({ dispatch, commit, state }, endDateTo) {
    commit(SET_END_DATE, find(state.availableDates, date => date.to === endDateTo))
  },
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/lasGraphs/viewership/dateRange/store/actions.js